import React, {Component} from 'react';
import "./App.css";



class Geschehen extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">

	<div className="contentHome" >	

	<div className="Frei" >
	
	<h2>Willkommen!<br/>in der Corona-Diktatur.<br/>---<br/>The Great Reset<br/>---<br/>Die Neue Weltordnung</h2><h4>Menschen, von denen man es nie für möglich gehalten hätte,<br/>brüllen "HEIL Corona".<br/>
	Sie tragen stolz ihr Parteiabzeichen, die Maske.<br/>
	Je weniger Luft sie bekommen,<br/>dasto moralisch erhabener fühlen sie sich.<br/>
	Sie merken nicht, wie der Freie Mensch in ihnen erstickt wird.</h4>
	
		
		<div className="Ein">
		
			<br/>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=qoRFLX9V_kU" target="_blank" >
			Nachschlag (9): Revolution / Schuldenbremse / Game Over Ukraine 08.12.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=bo-84Z4Er7Y&t=15s" target="_blank" >
			"Land ohne Mut" - Prof. Dr. Michael Esfeld in der Reihe "Freiheit im Dialog" mit Hartmut Haase 15.10.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=jNl93VMIH1U" target="_blank" >
			Deutschland 2023: Ein Staat wird übergriffig - TE Wecker am 03.10.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=EfLZ75dNP9k" target="_blank" >
			Heiko Schöning warnt: Der nächste Angriff sind Biowaffen und Bakterien! 09.09.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=E0cDIJdg9ac" target="_blank" >
			EZB-Insiderin gibt zu: E-Euro dient Überwachung 18.08.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=PaV5xu3v4Ms" target="_blank" >
			Martin Haditsch 02.08.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://pressefreiheit.rtde.live/international/174350-internationale-anwaltskonferenz-wir-muessen-diktatur/" target="_blank" >
			Internationale Anwaltskonferenz: Wir müssen die Diktatur der Weltgesundheitsorganisation stoppen 04.07.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/neue-mauer-ampel-will-ausreiseverbote-fuer-regierungskritiker/" target="_blank" >
			Neue „Mauer“? Ampel will Ausreiseverbote für Regierungskritiker 18.07.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XY2EqqXLPaE" target="_blank" >
			EU: Kopfsprung in die Diktatur! 14.07.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ADFTxp0FAdw" target="_blank" >
			Michael Ballweg: Digitaler Widerstand — Wie schützen vor Staat & Co.? 22.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://telegra.ph/EU-Impfzertifikat-soll-Modell-für-künftige-WHO-Totalüberwachung-werden-06-06" target="_blank" >
			EU-Impfzertifikat soll Modell für künftige WHO-Totalüberwachung werden 06.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=9_dKXEPJs5s" target="_blank" >
				WHO will neuen Pandemievertrag - TE Wecker am 04.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://report24.news/diktatur-nordkorea-und-ukraine-ins-fuehrungsgremium-der-who-gewaehlt/?feed_id=31045" target="_blank" >
				Diktatur Nordkorea und Ukraine ins Führungsgremium der WHO gewählt 03.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_HaZKy-3lz0&t=63s" target="_blank" >
			Willkommen im Unrechtsstaat / Nacktes Niveau 22.04.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=e_pLk1rruLY" target="_blank" >
			Die Psychologie der Klimakleber (Raphael Bonelli) 15.04.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nxlNsVSsxBg" target="_blank" >
			"Ungeimpfte ins Lager" - Unterschriften sammeln! 2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=PpgScUbudOw" target="_blank" >
			Cancel Culture: Wie werden Kritiker mundtot gemacht? TE Wecker am 25.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BRdKllRo8Bs" target="_blank" >
			Talfahrt 22.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=QVGdNJV5TUM" target="_blank" >
			RUBIKON: Im Gespräch: „Endspiel um die Freiheit“ (Ken Jebsen, Marcus Klöckner & Roland Rottenfußer) 19.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=NSYsyq9YvuU" target="_blank" >
					Zukunft: WHO übernimmt die Macht | Corona und wie es weiter geht 15. März 2023
					</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Lk9nIpwHPeI" target="_blank" >
			Was ist nur los mit Euch? 
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=fIbqpEJbO6k" target="_blank" >
			Nordstream-Sprengung: Was wusste Scholz? - Weltwoche Daily DE, 28.02.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=AwwSjmjULdk" target="_blank" >
			Ungarische Polizei sucht deutsche ANTIFA! 16.02.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://auf1.tv/stefan-magnet-auf1/anschlag-durch-who-das-was-jetzt-auf-uns-zukommt-ist-noch-viel-brutaler/" target="_blank" >
					Anschlag durch WHO: Das, was jetzt auf uns zukommt, ist noch viel brutaler! 14.02.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/lagebesprechung-auf1/lagebesprechung-auf1-zum-great-reset-fuer-das-regime-geht-es-jetzt-um-alles/" target="_blank" >
			Lagebesprechung AUF1 zum Great Reset: „Für das Regime geht es jetzt um alles“ 22.12.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=m1-KwLedfRo" target="_blank" >
			Du darfst dich nur noch 15 min frei bewegen pro Tag!   13.12.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=XtEnxSd7XAA" target="_blank" >
			Reichsbürger wollten Regierung stürzen! Das mediale Schlachtfest für alle Kritiker beginnt   08.11.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/studie-belegt-zensur-von-andersdenkenden/" target="_blank" >
			Studie belegt Zensur von Andersdenkenden   15.11.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/stefan-magnet-auf1/toedliche-agenda-der-plan-ist-durchschaut/?mc_cid=fada2a2885" target="_blank" >
			Tödliche Agenda: Der Plan ist durchschaut!   12.11.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Lwflj8_vmgI" target="_blank" >
			Ende der Meinungsfreiheit - Auf dem Weg in eine illiberale Gesellschaft?   04.11.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://clikview.com/watch/the-big-reset-movie-german-version_EIeqHyYMmhSRRZP.html" target="_blank" >
			<strong>The Big Reset</strong> Movie - GERMAN version   18.10.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=6yc8APemfL8" target="_blank" >
			Neuer Volksverhetzungsparagraph bedroht auch Post- und Telekommunikationsgeheimnis!   30.10.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://t.me/Robertmatuschewski/2852" target="_blank" >
				Eu Geheimarmee gegen das Volk!?   29.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=g5lFtpaP3cU" target="_blank" >
			Oberster Richter bläst zur Jagd auf Regierungskritiker   16.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=pxbBpyy7qmQ" target="_blank" >
				<strong>The Great Reset</strong>  - Gibt es einen Ausweg?   14.07.2022
			</a>

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=x-KVcNFJXzE" target="_blank" >
				Unser Grundgesetz nach Scheitern von Great Reset & Agenda 2030   17.06.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.linkedin.com/posts/julian-reichelt_was-im-neuen-verfassungschutzbericht-steht-ugcPost-6940337512024309760-08tQ?utm_source=linkedin_share&utm_medium=ios_app" target="_blank" >
				Julian Reichel, das neue Verfassungsschutzgesetz 09.06.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://pressecop24.com/juristen-schlagen-alarm-die-who-macht-uns-zu-sklaven-im-dauer-notstand/" target="_blank" >
					Juristen schlagen Alarm! Die WHO macht uns zu Sklaven im Dauer-Notstand! 03.06.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/stefan-magnet-auf1/thorsten-schulte-deutsche-und-russen-haben-einen-gemeinsamen-feind/" target="_blank" >
			Thorsten Schulte: Deutsche und Russen haben einen gemeinsamen Feind!  16.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=hQW7W2O_7jI" target="_blank" >
					Premierminister von Malaysia, Dr. Mahathir Mohamad, auf der intern. Konferenz "NEW WORLD ORDER"  19.10.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Umowp0Jeaug"  target="_blank">
				Wer regiert die Welt? <strong>Der Große Reset</strong> Die Durchführung, die Zusammenhänge - Ernst Wolff 24.05.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BPVP5WvPKZY&t=3373s"  target="_blank">
				<strong>Der Große Reset</strong> - Robert Stein
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=UgOdfuPYebI" target="_blank" >
			<strong>Great Reset</strong> Die Abschaffung der Seele  30.05.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.weforum.org/agenda/2020/11/the-great-reset-building-future-resilience-to-global-risks/"  target="_blank">
				World Economic Forum<br/><strong>The Great Reset</strong>
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=N92xz3Ma1ik"  target="_blank">
				Der Neuanfang! <strong>The Great Reset</strong>
				<br/>Bernie aus Australien  01.12.2020
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=LxekIdbALMQ" target="_blank" >
			So greift der Staat in Ihre Privatsphäre ein (Gudula Walterskirchen) 20.05.2022
			</a>					
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Fugk6Vv67y8"  target="_blank">
				Offener Brief von Erzbischof Vigano
				<br/><strong>The Great Reset</strong>
			</a>

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=i1HW7yLEjBk" target="_blank" >
			Totale Überwachung: Psychiater reagiert auf das "Sozialkredit-System" (Raphael Bonelli) 17.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=bGrq9PwgQOc" target="_blank" >
				Regierung bringt Chinas Punktesystem ins Spiel - KLARTEXT 30.05.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=wYf-3PhzAJM"  target="_blank">
				DER PERFIDE PLAN DES WORLD ECONOMIC FORUM 02.08.2020
			</a>	
			<a className="videoText"  rel="noopener" href="https://report24.news/aufgedeckt-alle-3-800-absolventen-von-klaus-schwabs-globalistischen-wef-ausbildungsprogrammen/" target="_blank" >
					Aufgedeckt: Alle 3.800 Absolventen von Klaus Schwabs globalistischen WEF-Ausbildungsprogrammen 10.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://apolut.net/sucharit-bhakdi-bedrueckende-nachrichten/" target="_blank" >
				Sucharit Bhakdi – Bedrückende Nachrichten 17.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=iBtOrjulS8c" target="_blank" >
				Entfremdung 30.04.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/systemfehler-geldsystem-auf1/systemfehler-geldsystem-wer-regiert-die-welt/" target="_blank" >
				Systemfehler Geldsystem: Wer regiert die Welt? 17.04.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=h1q9-8nV3aM" target="_blank" >
			Mit dem WHO-Pandemievertrag in den autoritären Transhumanismus   07.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=m7PrTsJdy0w" target="_blank" >
			Es ist nur... 29.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4KBgYZKT2lg" target="_blank" >
			Neue Illegalität | von Jürgen Schmid 28.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=_GXwRlkTHCY" target="_blank" >
			Wer hat Angst vor Klaus Schwab? 17.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=-Bwon4xdDX0" target="_blank" >
				Der Weg schiebt sich beim Gehen unter die Füße | Charles Eisenstein 21.02.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=fGwTPpsYGDA" target="_blank" >
				ZDF-Urgestein Hahne fordert: Corona-Politik muss vor Gericht 20.02.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=BYscdRhhy38" target="_blank" >
						Peter Weber Live - Wollt ihr die Menschheit ausrotten? 15.02.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=2qj0gdulZow" target="_blank" >
				Kämpfen oder nicht?  09.02.2022
			</a>
		
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=viiVMkBRoTg" target="_blank" >
			"Wissenschaft und Politik – Experten an die Macht?" 16.09.2021
			</a>
			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=1Wffmrgxpfg" target="_blank" >
				Spaziergang verboten: Die totalitäre Fratze der Politik 29.12.2021
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=1Wffmrgxpfg" target="_blank" >
			Spaziergang verboten: Die totalitäre Fratze der Politik 29.12.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=OCKx_kn2uqI" target="_blank" >
				Gibt es noch Hoffnung? | KAISER + LENZ 25.12.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://rumble.com/vr4emv-interview-paul-brandenburg.html" target="_blank" >
				"Faschistischer Unsinn" - Dr. Paul Brandenburg über die Corona-Maßnahmen 22.12.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=DJ5M0Q6flYg" target="_blank" >
						Der neue Moralismus ist dröhnende Leere - Weltwoche Daily Deutschland, 21.12.2021
			</a>					
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=l5l8tnAMv2Q" target="_blank" >
				BMI-Geheimpapier bei Reitschuster   13.12.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=SJqGEdVvXp0" target="_blank" >
				Brisante Enthüllungen: Diese Corona-Fakten werden zensiert!   12.12.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/kommen-lager-fuer-positiv-getestete-china-als-modell-fuer-deutschland/" target="_blank" >
				Kommen Lager für positiv Getestete? China als Modell für Deutschland?   11.12.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/impfpflicht-welcome-corona-leugner-als-moerder/" target="_blank" >
				„Corona-Leugner“ als Mörder<br/>Menschenrechtler auf Abwegen  10.12.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=i5YnYw38k90" target="_blank" >
						Kantinen-Segregation - Stück für Stück in die Apartheit 01.11.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.fromrome.info/2021/10/31/we-are-at-the-great-separation-it-is-now-humanity-vs-the-deathvaxx-monsters/" target="_blank" >
				WE ARE AT THE GREAT SEPARATION
			</a>
		
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ZKcDLSRUxfI" target="_blank" >
				Der Staat begeht Machtmissbrauch | Ralf Ludwig
			</a>
			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=k0sRNnyktYY" target="_blank" >
					„Karl Lauterbach darf unter keinen Umständen Gesundheitsminister werden“ 07.10.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://report24.news/jetzt-auch-in-norwegen-alle-covid-beschraenkungen-aufgehoben/" target="_blank" >
					Jetzt auch in Norwegen: Alle Covid-Beschränkungen aufgehoben 28.09.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=W69V5o_K2wk" target="_blank" >
			Der Weg in den Totalitarismus 08.08.2021
			</a>

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FUadhslzJbM" target="_blank" >
				Gelten die Grundrechte nur noch für Regierungstreue? 29.07.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://t.me/pankalla/3740" target="_blank" >
				Mitterand Berater 23.06.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=xzcK4A26-q8" target="_blank" >
				Great Reset? Das Außenministerium über die globale Ordnung nach Corona 09.06.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://unser-mitteleuropa.com/cia-neurobiologie-experte-ueber-die-steuerung-des-menschlichen-gehirns-mittels-rna-impfstoffen/" target="_blank" >
				RNA-Impfstoffe zur Steuerung des menschlichen Gehirns 09.06.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=I0N_mj3MGJ4" target="_blank" >
				Wir haben euch durchschaut! 07.06.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.frei3.de/article/362b5563-e172-43ca-8f25-9bfa91d65918" target="_blank" >
				Volle Grundrechte nur für Geimpfte? Ungeimpfte als Pariah? 26.04.2021
			</a>		
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=RHfx4zGLwMk" target="_blank" >
				Erklärung des Infektionsschutzgesetzes von Markus Haintz
			</a>
			<a className="videoText"  rel="noopener" href="https://www.bitchute.com/video/qHkhwydpUosG/" target="_blank" >
				Interview mit Prof. Dr. Sucharit Bhakdi 02.05.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=_pgjcxcASEY" target="_blank" >
				Bundesministerium für Umwelt denkt den <strong>Great Reset </strong> 13.05.2021
			</a>				
			 
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=2l-ULD_8QJw" target="_blank" >
				Dr. Markus Krall empört - DAS wollen SIE mit UNS machen! 07.05.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://philosophia-perennis.com/2021/05/07/bundesrat-heute-wird-deutschland-zum-staat-in-dem-man-sich-grundrechte-spritzen-lassen-muss/" target="_blank" >
				Heute wird Deutschland zum Staat, 
				in dem man sich Grundrechte spritzen lassen muss! 07.05.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.wochenblick.at/mysterioeses-covid-19-sterben-von-politikern-in-afrika/" target="_blank" >
				Mysteriöses Covid-19-Sterben von Politikern in Afrika 06.05.2021
			</a>									
			<a className="videoText" rel="noopener"  href="https://odysee.com/@MenschenMachenMut:c/Update-Reiner-Fuellmich:d" target="_blank" >
				Update von RA Füllmich 13.04.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kg-Icy1DCpg" target="_blank" >
				Merkel: Es wird keine neuen Freiheiten geben<br/>02.02.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=L8synzDTCw8" target="_blank" >
				<strong>Amnesty International</strong> kritisiert <br/>07.04.2021
			</a>					
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Cxyrd_Duq90"  target="_blank">
				Wo sind unsere kritischen Denker?<br/>Gunnar Kaiser  01.06.2020
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=iEHvxehoxSo&feature=youtu.be"  target="_blank">
				Hört auf zu jammern - wehrt euch!<br/>19.02.2021
			</a>				
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-opKoSh7lsk"  target="_blank">
				Untersuchungsausschuss Corona-Ausschuss<br/>
				Schlussstrich 2020  01.01.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=kFK361YV5Aw"  target="_blank">
				Boris Reitschuster: Stanford-Studie	12.01.2021
			</a>							
								
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BPVP5WvPKZY&t=3373s"  target="_blank">
				<strong>Der große Reset</strong> - Robert Stein
			</a>
			<a className="videoText" rel="noopener"  href="https://www.weforum.org/agenda/2020/11/the-great-reset-building-future-resilience-to-global-risks/"  target="_blank">
				World Economic Forum<br/><strong>The gread Reset</strong>
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=N92xz3Ma1ik"  target="_blank">
				Der Neuanfang! <strong>The gread Reset</strong>
				<br/>Bernie aus Australien  01.12.2020
			</a>			
								
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Fugk6Vv67y8"  target="_blank">
				Offener Brief von Erzbischof Vigano
				<br/><strong>The gread Reset</strong>
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=wYf-3PhzAJM"  target="_blank">
				DER PERFIDE PLAN DES WORLD ECONOMIC FORUM 02.08.2020
			</a>					
	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=QSFiiiZ3q0k"  target="_blank">
			<strong>Der große Reset</strong> - The Truth of It
				<br/>Australian Christian Lobby  28.11.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-YgNzzNkeXc&feature=youtu.be"  target="_blank">
				Transhumanismus
				<br/>WEF-Gründer Schwab  02.12.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BKWceSwhQvI"  target="_blank">
			Valentinstag! Liebe für ALLE❤❤❤<br/>!!! SATIRE!!!  14.02.2021
			</a>				
			<a className="videoText" rel="noopener"  href="https://www.bitchute.com/video/HOMRjO0xNJgZ/"  target="_blank">
				Die magische Virusrettung der Finanzelite?  06.01.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XYbSE6PTgOI"  target="_blank">
				Berlin - Boris Reitschuster	18.11.2020
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ixYr0yuFUXE"  target="_blank">
				Ein Zeitalter der Unfreiheit zieht herauf
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=SSnJhHOU_28"  target="_blank">
				Paul Schreyer: Pandemie-Planspiele
			</a>					
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=G4IbmLOPNjs"  target="_blank">
				Wie geht es Ihnen Hr Prof Van der Bellen
			</a>		
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=7GH8Va7jtaM&t=6s"  target="_blank">
				Über die Zensur im Corona-Jahr 2020!<br/>Raphael Bonelli 28.11.2020
			</a>																	
			<a className="videoText" rel="noopener"  href="https://rumble.com/vc5h1e-leak-aus-kanada-weltweite-konzentrationslager-fr-impfverweigerer-geplant.html"  target="_blank">
				Konzentrationslager für Impfverweigerer 24.12.2020
			</a>		
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=STn8bgiCoJ4"  target="_blank">
					Die totale Kontrolle 21.12.2020
			</a>												
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_c_ec3oUXVc&feature=youtu.be"  target="_blank">
				Die nächste Krise ist geplant 22.11.2020				
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=eq5zESrG1UI"  target="_blank">
				Die große Selbstzerstörung 13.12.2020
			</a>					
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FjBmfqlptv8"  target="_blank">
				hört hört   November 89				
			</a>				
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=3A_sYywZtoc&feature=youtu.be"  target="_blank">
				Mit Verschwörungstheorien aufgeräumt 26.11.2020				
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=5CBhyslT91g&t=1889s"  target="_blank">
				Spaltet die diabolische Kommunikation unsere Gesellschaft? Raphael Bonelli				
			</a>													
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=jLpJ_VUsNRw"  target="_blank">
				Dr. med. Carola Javid-Kistel	13.11.2020
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Ao817RXRIzs"  target="_blank">
				Links? Rechts? Linksextrem? Rechtsextrem?
				Alexander Ehrlich 29.12.2020
			</a>						
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=wPtWa4pmbrc"  target="_blank">
				Hansjörg Müller MdB: EU plant	19.10.2020
			</a>					

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=t2_ovxf8Idw"  target="_blank">
				Guten Tag Finanzmacht
			</a>	
										
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=JBdELXzyYUU" target="_blank" >
				Roland Tichy	14.12.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=u11Dx9s3FQs" target="_blank" >
				Gunnar Kaiser 07.06.2020
			</a>
			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=xRfkBvpXSt4" target="_blank" >
				RPP	17.10.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=gCqJK7SiV_Y" target="_blank" >
				Frau Dr. med. Gerlind Läger, Internistin
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ABYecv9g2Wg" target="_blank" >
				The moment of change
			</a>	

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=EvYhCY7Xi3E"  target="_blank">
				Pfarrer Jürgen Fliege
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=r9bHbivT0jk&feature=youtu.be"  target="_blank">
				BESONDERE HELDEN<br/>BESIEGE DIE ANGST<br/>STEHE AUF UND TUE WAS !
			</a>														
			<a className="videoText" rel="noopener"  href="https://www.frei3.de/article/e904c055-d032-4e50-93fc-06871b564585" target="_blank" >
				Bananenrepublik			
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Z_jLLgbHjxo"  target="_blank">
				Nina Proll
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
			</a>						
			

		</div>
	</div>
	
</div>




</div>

  );
};
};

export default Geschehen;
